export default [
  {
    path: "/",
    name: "首页",
    subs: [],
  },
  {
    path: "/about",
    name: "走进志扬",
    subs: [
      {
        path: "/about/leaderSay",
        name: "创始人说",
      },
      {
        path: "/about/intro",
        name: "企业简介",
      },
      {
        path: "/about/history",
        name: "发展历程",
      },
      {
        path: "/about/organization",
        name: "组织架构",
      },
      {
        path: "/about/certification",
        name: "企业资质",
      },
      {
        path: "/about/honor",
        name: "企业荣誉",
      },
    ],
    expand: false,
  },
  {
    path: "/culture",
    name: "志扬文化",
    subs: [],
  },
  {
    path: "/team",
    name: "志扬团队",
    subs: [
      {
        path: "/team/idea",
        name: "用人理念",
      },
      {
        path: "/team/empowerment",
        name: "人才赋能",
      },
      {
        path: "/team/teamStyle",
        name: "团队风采",
      },
      {
        path: "/team/partner",
        name: "企业合伙人",
      },
      {
        path: "/team/job",
        name: "招贤纳士",
      },
    ],
    expand: false,
  },
  {
    path: "/product",
    name: "志扬产品",
    subs: [
      {
        path: "/product/productType",
        name: "产品类别",
      },
      {
        path: "/product/qualityControl",
        name: "品控体系",
      },
      {
        path: "/product/warning",
        name: "风控预警",
      },
      {
        path: "/product/valueSystem",
        name: "价值再造",
      },
    ],
    expand: false,
  },
  {
    path: "/innovate",
    name: "科技创新",
    subs: [
      {
        path: "/innovate/productCenter",
        name: "产品中心",
      },
      {
        path: "/innovate/controlPlatform",
        name: "云控平台",
      },
      {
        path: "/innovate/academe",
        name: "志扬学苑",
      },
    ],
    expand: false,
  },
  {
    path: "/case",
    name: "志扬案例",
    subs: [
      {
        path: "/case/client",
        name: "合作客户",
      },
      {
        path: "/case/case",
        name: "代表案例",
      },
      {
        path: "/case/performance",
        name: "公司业绩",
      },
    ],
    expand: false,
  },
  {
    path: "/files",
    name: "资源共享",
    subs: [
      {
        path: "/files/policy",
        name: "政策规范",
      },
      {
        path: "/files/information",
        name: "价材信息",
      },
      {
        path: "/files/standard",
        name: "指标数据",
      },
    ],
    expand: false,
  },
  {
    path: "/news",
    name: "资讯动态",
    subs: [
      {
        path: "/news/company",
        name: "公司动态",
      },
      {
        path: "/news/event",
        name: "新闻事件",
      },
      {
        path: "/news/report",
        name: "公益事业报道",
      },
      {
        path: "/news/industry",
        name: "行业相关",
      },
    ],
    expand: false,
  },
  {
    path: "/contact",
    name: "联系我们",
    subs: [
      {
        path: "/contact/job",
        name: "人才招聘",
      },
      {
        path: "/contact/map",
        name: "地图展示",
      },
    ],
    expand: false,
  },
];
